import React from 'react';
import { useShippingCalculator } from './hooks/use-shipping-calculator';
import { CalculatorSection } from './components/calculator-section';
import style from './shipping-rate-calculator.module.less';

/**
 * ShippingRateCalculator component
 * Displays a shipping rate calculator that matches the design in the image
 * @returns {React.ReactElement} ShippingRateCalculator component
 */
export const ShippingRateCalculator = () => {
  const calculatorProps = useShippingCalculator();

  return (
    <div className={style['shipping-rate-calculator-wrapper']}>
      <CalculatorSection
        {...calculatorProps}
        className={style['shipping-rate-calculator']}
        isHorizontalLayout
        stylesheet={style}
        weightContainerClassName={style['custom-number-input']}
        weightInputClassName={style['weight-number-input']}
      />
    </div>
  );
};
